<template lang="pug">
  div
    img(
      src="../assets/about.png"
      class="img-fluid"
    )
    
    div(class="container text-left")
      b-row
        h1(class="text-left mt-3") Shi Guorui
      b-row 1964 Born in Shanxi, China
      b-row 1992 Graduated from Nanjing Normal University majoring in photography 
      b-row Currently lives and works in Beijing and New York
      div(class="solo")
        b-row
          h4(class="mt-5 mb-3") Solo Exhibition
        b-row(
          v-for="solo in soloExhibition"
          class="mb-3"
        )
          b-col(
            cols="2"
            class="align-self-start"
          ) {{ solo.year }}
          b-col(
            cols="6"
            class="align-self-start"
          ) 
            div(v-if="solo.link")
               a(:href="solo.link") {{ solo.des }}
            
            div(v-else) {{ solo.des }}
              
          b-col(
            cols="4"
            class="align-self-top"
          ) {{ solo.location }}
      div(class="group")
        b-row
          h4(class="mt-2 mb-3") Group Exhibition
        b-row(
          v-for="group in groupExhibition"
          class="mb-3"
        )
          b-col(
            cols="2"
          ) {{ group.year }}
          b-col(
            cols="6"
            class="align-self-start"
          )
            div(v-if="group.link")
               a(:href="group.link") {{ group.des }}

            div(v-else) {{ group.des }}
          b-col(
            cols="4"
            class="align-self-top"
          ) {{ group.location }}
      div(class="publicCollection")
        b-row
          h4(class="mt-2 mb-3") Public Collection
        b-row(
          v-for="collect in publicCollection"
          class="mb-2 ml-1 mr-1"
        ) {{ collect }}

</template>
<script>
export default {
  data() {
    return {
      soloExhibition: [
        {
          year: "2019",
          des: "Ab/Sense-Pre/Sense",
          location: "Thomas Cole National Historic Site, Catskill NY, USA",
          link: "https://thomascole.org/absensepresense/"
        },
        {
          year: "2017",
          des: "Light Frequencies, Camera Obscura Images of Hong Kong",
          location: "10 Chancery Lane Gallery Hong Kong",
          link:
            "http://www.10chancerylanegallery.com/press/detail/LightFrequenciesCame/en/"
        },
        {
          year: "2011",
          des: "Rebirth",
          location: "L&M Arts, Los Angeles, California, USA",
          link: "https://www.levygorvy.com/exhibitions/shi-guorui-rebirth/"
        },
        {
          year: "2010",
          des: "The Same is Not the Same: Shi Guorui & Andrea Good",
          location: "Offene Kirche Elisabethen, Basel, Switzerland"
        },
        {
          year: "2008",
          des: "New Works by Shi Guorui",
          location: "10 Chancery Lane, Hong Kong",
          link:
            "http://www.10chancerylanegallery.com/exhibitions/2008/New_Works_by_ShiGuorui/en/"
        },
        {
          year: "2007",
          des: "Reproduction and Refashioning",
          location: "de Young Museum, San Francisco, California, USA",
          link:
            "https://deyoung.famsf.org/deyoung/exhibitions/shi-guorui-reproduction-and-refashioning"
        },
        {
          year: "2005",
          des: "Shanghai, Shi Guorui Camera Obscura",
          location: "Chinese Contemporary Gallery, London, UK",
          link: "https://www.chinesecontemporary.com/exhibitions_2007_12_1.htm"
        },
        {
          year: "2002",
          des: "The Great Wall",
          location: "Pingyao International Photography Festival, China"
        },
        {
          year: "2001",
          des: "Yungang Grottoes",
          location: "Pingyao International Photography Festival, China"
        }
      ],
      groupExhibition: [
        {
          year: "2016",
          des: "Chinese Whispers Recent Art from The Sigg&M+Sigg Collections",
          location: "Kunstmuseum Bern, Switzerland ",
          link: "https://www.mak.at/en/chinesewhispers"
        },
        {
          year: "2015",
          des:
            "Dislocation:Urban Experience in Contemporary East Asian Photography",
          location:
            "Smith College Museum of Art, Northampton, Massachusetts, USA"
        },
        {
          year: "2014",
          des: "Myth/History, Yuz Collection of Contemporary Art",
          location: "Yuz Museum, Shanghai, China",
          link: "http://www.yuzmshanghai.org/mythhistory/?lang=en"
        },
        {
          year: "2013",
          des: "Poetics of Light",
          location: "The New Mexico History Museum, Santa Fe, New Mexico, USA",
          link: "http://www.nmhistorymuseum.org/pinhole/"
        },
        {
          year: "2013",
          des: "Ink Art: Past as Present in Contemporary China",
          location: "The Metropolitan Museum of Art, New York, New York, USA",
          link: "https://www.metmuseum.org/exhibitions/listings/2013/ink-art"
        },
        {
          year: "2013",
          des: "Rewriting The Landscape: India and China",
          location:
            "National Museum of Modern and Contemporary Art Korea, Seoul, Korea",
          link:
            "https://www.mmca.go.kr/eng/exhibitions/exhibitionsDetail.do?exhId=201310310000100"
        },
        {
          year: "2011",
          des:
            "Shanshui---Poetry without Sound ? Landscape in Chinese Contemporary Art-Works From Sigg Collection",
          location: "Museum of Art ,Lucerne, Switzerland"
        },
        {
          year: "2010",
          des:
            "Chinese Windows 2010: Big Draft – Shanghai - Chinese Contemporary Art from the Sigg Collection",
          location: "Kunstmuseum Bern, Switzerland"
        },
        {
          year: "2010",
          des:
            "The State of Things: The Exchanging of Contemporary Art Between China and Belgium",
          location: "Centre for Fine Arts, Beijing, China",
          link:
            "http://www.namoc.org/en/news/news2010/201304/t20130423_243995.htm#.XlSMspNKiMI"
        },
        {
          year: "2010",
          des: "Re-Imagining the Real Photography Show",
          location: "Yuz Museum, Jakarta Indonesia"
        },
        {
          year: "2009",
          des:
            "The State of Things, The Exchanging of Contemporary Art Between China and Belgium",
          location: "BOZAR, Belgium",
          link:
            "https://www.bozar.be/en/activities/2326-the-state-of-things-brusselsbeijing"
        },
        {
          year: "2009",
          des:
            "Reversed Images: Representations of Shanghai and Its Contemporary Material Culture",
          location:
            "The Museum of Contemporary Photography, Chicago, Illinois, USA",
          link:
            "https://www.mocp.org/exhibitions/2000/9/reversed-images-representations-of-shanghai-and-its-contemporary-material-culture.php"
        },
        {
          year: "2009",
          des: "An Autobiography of the San Francisco Bay Area, SF Camerawork",
          location: "San Francisco, California, USA",
          link: "https://sfcamerawork.org/archive-2009-exhibitions"
        },
        {
          year: "2008",
          des: "Beijing 2008",
          location: "The Olympic Museum Lausanne, Switzerland"
        },
        {
          year: "2008",
          des: "China Gold Exhibit",
          location: "Museum Maillol, Paris, France"
        },
        {
          year: "2008",
          des: "Shanghai Kaleidoscope Exhibition",
          location: "The Royal Ontario Museum, Toronto, Canada",
          link:
            "https://www.rom.on.ca/en/exhibitions-galleries/exhibitions/shanghai-kaleidoscope"
        },
        {
          year: "2008",
          des:
            "GO CHINA---New World Order Present-day Installation Art and Photography",
          location: "Groninger Museum, Groningen, The Netherlands"
        },
        {
          year: "2007",
          des: "Red Hot - Asian Art Today From The Chaney Family Collection",
          location: "The Museum Of Fine Arts, Houston, Texas, USA",
          link:
            "https://www.houstonpress.com/arts/red-hot-asian-art-today-from-the-chaney-family-collection-6543210"
        },
        {
          year: "2007",
          des: "ZHUYI! Contemporary Photography from China",
          location: "The ARTIUM Museum of Contemporary Art, Victoria, Spain"
        },
        {
          year: "2006",
          des: "Mahjong - Contemporary Chinese Art from the Sigg Collection",
          location: "The Hamburger Kunsthalle, Germany",
          link:
            "https://www.e-flux.com/announcements/42162/mahjong-contemporary-chinese-art-from-the-sigg-collection/"
        },
        {
          year: "2006",
          des: "Entry Gate: Chinese Aesthetics of Heterogeneity",
          location: "Shanghai MoCA Biennial, Shanghai, China"
        },
        {
          year: "2006",
          des: "Transformations New Chinese Photography",
          location: "The Franmentle Art Centre, Australia "
        },
        {
          year: "2005",
          des: "Beyond Delirious, Ella Fontanals Cisneros Collection",
          location: "Miami, Florida, USA",
          link:
            "https://www.cifo.org/index.php/visit/cifo-store-cart/item/624-beyond-delirious-indeterminate-states"
        },
        {
          year: "2005",
          des: "Past and Future Contemporary Art Exhibition",
          location: "Krings-Ernst gallery, Koln, Germany",
          link:
            "https://smartmuseum.uchicago.edu/exhibitions/between-past-and-future-new-photography-and-video-from-china/"
        },
        {
          year: "2005",
          des: "“HJONG”---Chinesische Gegenwartskunst aus der Sammlung Sigg",
          location: "The Museum of Fine Arts, Berne, Switzerland"
        },
        {
          year: "2005",
          des: "Chinese Contemporary Photography",
          location: "The Trastevere Museum of Rome, Rome, Italy"
        },
        {
          year: "2005",
          des: "Re-viewing the City, Guangzhou Photo Biennial",
          location: "The Fine Arts, Museum of Guangdong, Guangzhou, China"
        },
        {
          year: "2004",
          des:
            "Public Space and Urban Environment The 1st Architectural Biennial",
          location: "Beijing, China"
        },
        {
          year: "2003",
          des: "Promenade e’difiante et Curieuse au Pavillon des Images",
          location: "Paris, France"
        },
        {
          year: "2002",
          des: "The 2nd International Art Biennial of Buenos Aires",
          location: "National Museum of Argentina, Buenos Aires, Argentina"
        }
      ],
      publicCollection: [
        "The Ministry of Culture in France",
        "Funds National d'art Contemporary, Paris, France",
        "The Sigg Collection, Switzerland",
        "Cisneros Fontanals Art Foundation, Miami, Florida, USA",
        "The M.H. de Young Museum, San Francisco, California, USA",
        "Museum of Contemporary Art, Los Angeles, California, USA",
        "The Speyer Family Collection, New York, USA",
        "East/West Bank, Los Angeles, California, USA",
        "FOR-SITE Foundation, San Francisco, California, USA",
        "The Chaney Family Collection, Houston, Texas, USA",
        "Museum of Contemporary Photography, Chicago, Illinois, USA",
        "Herzog & de Meuron Architekten AG, Switzerland",
        "The New Mexico History Museum, Santa Fe, New Mexico, USA",
        "Yuz Museum, Shanghai, China",
        "Guangdong Fine Art Museum, Guangzhou, China",
        "Zhengzhou Museum, Zhengzhou, China",
        "Stanford University, Palo Alto, California, USA",
        "The Palm Springs Art Museum, California, USA",
        "Nevada Museum of Art, Nevada, USA",
        "Eric & Yijing Li Collection, China",
        "Los Angeles County Museum of Art, California, USA",
        "National Gallery of Australia, Canberra Australia",
        "Hong Kong M+ Museum"
      ]
    };
  }
};
</script>

<style lang="less">
.about_img {
  object-fit: scale-down;
}
</style>